import * as React from 'react';
import ProductOptionsStrings from './ProductOptionsStrings';
import { StyledInfoTable } from '../../Common/StyledInfoTable';
import { Colors, Spacing, Text } from '@doordash/design-language';
import Button from '@doordash/component-button';
import { ddfwPlatformRowData, accountRowData } from './ProductOptionsPageData';
var EMPLOYEE_MEAL_TABLE_COL_WIDTH = '300px';
var EmployeeMealTableSection = function (_a) {
    var sectionTitle = _a.sectionTitle, rowData = _a.rowData;
    return (React.createElement(StyledInfoTable.Body, null,
        React.createElement(StyledInfoTable.TR, null,
            React.createElement(StyledInfoTable.TD, { colSpan: 3, padding: Spacing.XSmall, backgroundColor: Colors.BackgroundSecondary },
                React.createElement(Text, { styles: Text.Styles.Body2 }, sectionTitle))),
        rowData.map(function (data) { return (React.createElement(StyledInfoTable.TR, { key: data.benefitName },
            React.createElement(StyledInfoTable.TD, { padding: Spacing.XSmall },
                React.createElement(Text, { styles: Text.Styles.Body2 }, data.benefitName)),
            React.createElement(StyledInfoTable.TD, { padding: Spacing.XSmall },
                React.createElement(Text, { styles: Text.Styles.Body2Emphasis, textAlign: Text.TextAlignments.Center }, data.smallTeam())),
            React.createElement(StyledInfoTable.TD, { padding: Spacing.XSmall },
                React.createElement(Text, { styles: Text.Styles.Body2Emphasis, textAlign: Text.TextAlignments.Center }, data.corporate())))); })));
};
var EmployeeMealOrderingTable = function (_a) {
    var onClickContactUs = _a.onClickContactUs, onClickSignupNow = _a.onClickSignupNow;
    return (React.createElement(StyledInfoTable, null,
        React.createElement(StyledInfoTable.Head, null,
            React.createElement(StyledInfoTable.TR, null,
                React.createElement(StyledInfoTable.TH, null, " "),
                React.createElement(StyledInfoTable.TH, { width: EMPLOYEE_MEAL_TABLE_COL_WIDTH },
                    React.createElement(Text, { styles: Text.Styles.Title2, textAlign: Text.TextAlignments.Center }, ProductOptionsStrings.smallTeam())),
                React.createElement(StyledInfoTable.TH, { width: EMPLOYEE_MEAL_TABLE_COL_WIDTH },
                    React.createElement(Text, { styles: Text.Styles.Title2, textAlign: Text.TextAlignments.Center }, ProductOptionsStrings.corporateOrdering())))),
        React.createElement(EmployeeMealTableSection, { sectionTitle: ProductOptionsStrings.doordashForWorkPlatform(), rowData: ddfwPlatformRowData }),
        React.createElement(EmployeeMealTableSection, { sectionTitle: ProductOptionsStrings.accountAndSupport(), rowData: accountRowData }),
        React.createElement(StyledInfoTable.Foot, null,
            React.createElement(StyledInfoTable.TR, null,
                React.createElement(StyledInfoTable.TH, null, " "),
                React.createElement(StyledInfoTable.TH, null,
                    React.createElement(Button, { onClick: onClickSignupNow }, ProductOptionsStrings.signUpNowButton())),
                React.createElement(StyledInfoTable.TH, null,
                    React.createElement(Button, { onClick: onClickContactUs }, ProductOptionsStrings.contactSalesButton()))))));
};
export default EmployeeMealOrderingTable;
